/**
 * PM12HelpFabGuard — keeps the floating help pill off the pricing Start buttons
 * on /pro-member-v12 (r8, 2026-09-23, Lars via Eleanor: "a covered button is a
 * cut-off button").
 *
 * While either `.pm12-pricing .pm12-plan__cta` intersects the viewport, the v12
 * page root carries `data-pm12-plans-in-view`; once neither does, it is removed.
 * pm12.css hides `.help-fab` from that attribute (fade, visibility hidden, no
 * pointer events). The widget (components/HelpFab.tsx) and help-chat.css are
 * untouched — this only toggles an attribute on the v12 root. Renders nothing.
 */

'use client';

import { useEffect } from 'react';

const ATTR = 'data-pm12-plans-in-view';

export default function PM12HelpFabGuard() {
  useEffect(() => {
    const root = document.querySelector<HTMLElement>('.pm12-page--v12');
    const ctas = document.querySelectorAll<HTMLElement>('.pm12-pricing .pm12-plan__cta');
    if (!root || ctas.length === 0 || typeof IntersectionObserver === 'undefined') return;

    const inView = new Set<Element>();
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) inView.add(entry.target);
        else inView.delete(entry.target);
      }
      if (inView.size > 0) root.setAttribute(ATTR, '');
      else root.removeAttribute(ATTR);
    });
    ctas.forEach((cta) => observer.observe(cta));

    return () => {
      observer.disconnect();
      root.removeAttribute(ATTR);
    };
  }, []);

  return null;
}
